module.exports = __webpack_public_path__ + "img/map-update.cddb6d62.svg";